import RefappVideoProvider from './components/base/provider.vue';
import RefappVideoBase from './components/base/video.vue';
import RefappVideo from './components/refapp-video.vue';
import RefappPlaylist from './components/refapp-playlist.vue';

export default {
  install(app) {
    const components = [RefappVideoProvider, RefappVideoBase, RefappVideo, RefappPlaylist];
    components.forEach((c) => app.component(c.name, c));
  },
};
